import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUploadQueueStore = defineStore('uploadQueue', () => {
    const queue = ref<string[]>([])
    const isRunning = ref(false)
    const concurrency = ref(1)

    const queuedCount = computed(() => queue.value.length)

    function enqueue(id: string) {
        if (!queue.value.includes(id)) queue.value.push(id)
    }

    function enqueueMany(ids: string[]) {
        const set = new Set(queue.value)
        ids.forEach(id => set.add(id))
        queue.value = [...set]
    }

    function dequeue(id: string) {
        queue.value = queue.value.filter(x => x !== id)
    }

    function clear() {
        queue.value = []
    }

    return {
        queue,
        isRunning,
        concurrency,
        queuedCount,
        enqueue,
        enqueueMany,
        dequeue,
        clear,
    }
}, {
    persist: {
        storage: localStorage,
        pick: ['queue'],
    },
})